<script setup lang="ts">
import AcmiGrid from './masterdata/AcmiGrid.vue';
import AircraftTypesGrid from './masterdata/AircraftTypesGrid.vue';
import ClientsGrid from './masterdata/ClientsGrid.vue';
import FlightNumbersGrid from './masterdata/FlightNumbersGrid.vue';
import RevVardocGrid from './masterdata/RevVardocGrid.vue';
import SeasonsGrid from './masterdata/SeasonsGrid.vue';
import CrewBriefingTemplatesGrid from './masterdata/CrewBriefingTemplatesGrid.vue';
</script>

<template>
  <div class="flex h-full flex-col gap-4">
    <div class="flex items-center justify-between">
      <h1>Reference data</h1>
    </div>

    <p-accordion multiple>
      <p-accordion-tab header="Clients">
        <ClientsGrid />
      </p-accordion-tab>

      <p-accordion-tab header="Seasons">
        <SeasonsGrid />
      </p-accordion-tab>

      <p-accordion-tab header="Document Templates">
        <CrewBriefingTemplatesGrid />
      </p-accordion-tab>

      <p-accordion-tab header="Aircraft Types">
        <AircraftTypesGrid />
      </p-accordion-tab>

      <p-accordion-tab header="Flight Number Ranges">
        <FlightNumbersGrid />
      </p-accordion-tab>

      <p-accordion-tab header="Pricing Parameters">
        <div class="flex flex-col gap-4">
          <RevVardocGrid />

          <AcmiGrid />
        </div>
      </p-accordion-tab>
    </p-accordion>
  </div>
</template>

<style scoped lang="scss">
h1 {
  margin: 0 !important;
}
</style>
